module.exports = __webpack_public_path__ + "img/icon-info-24px-mutted.6e75fd67.svg";